import { useMemo } from 'react';

import { useGetOptionsForCLA } from 'hooks/useGetOptionsForCLA';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import { singleSelectValueFormatter } from 'components/shared/DataGrid/utils/valueFormatters/singleSelectValueFormatter';

import { GridColDef } from '@mui/x-data-grid-pro';
import { AgeHoursTableData } from '../types';
import { Option } from 'components/shared/ControlledFields/ControlledSelect';

const useColumnDefinitions = () => {
  const { t } = useTranslation();
  const claOptions = useGetOptionsForCLA();

  return useMemo(() => {
    return generateColumns(t, claOptions);
  }, [t, claOptions]);
};

const generateColumns = (t: TFunction, claOptions: Option[]): GridColDef[] => [
  {
    field: 'claId',
    headerName: t('ageHours.grid.claId'),
    type: 'singleSelect',
    hideable: false,
    minWidth: 100,
    flex: 1,
    valueOptions: claOptions,
    valueFormatter: (value: AgeHoursTableData['claId']) => singleSelectValueFormatter(value, claOptions)
  },
  {
    field: 'yearValid',
    headerName: t('ageHours.grid.yearValid'),
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    minWidth: 100,
    flex: 1,
    valueFormatter: (value: AgeHoursTableData['yearValid']) => value
  },
  {
    field: 'ageYear',
    headerName: t('ageHours.grid.ageYear'),
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    minWidth: 100,
    flex: 1
  },
  {
    field: 'startHours',
    headerName: t('ageHours.grid.startHours'),
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    minWidth: 150,
    flex: 1
  },
  {
    field: 'hours',
    headerName: t('ageHours.grid.hours'),
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    minWidth: 150,
    flex: 1
  },
  {
    field: 'startHoursPlb',
    headerName: t('ageHours.grid.startHoursPlb'),
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    minWidth: 150,
    flex: 1
  },
  {
    field: 'hoursPlb',
    headerName: t('ageHours.grid.hoursPlb'),
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    minWidth: 150,
    flex: 1
  }
];

export default useColumnDefinitions;
